module.exports = __webpack_public_path__ + "img/charging_active.bcefed98.jpg";